const API_URL = process.env.REACT_APP_API_URL || 'https://g1sport.fr/api';
const BASE_URL = API_URL.replace('/api', ''); // Enlever /api pour avoir juste l'URL de base

export const getImageUrl = (imagePath: string | undefined): string => {
  if (!imagePath) return '';

  // Si c'est déjà une URL complète, la retourner telle quelle
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Nettoyer le chemin (enlever les / en début)
  const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;

  return `${BASE_URL}/${cleanPath}`;
};

export const getMediaUrl = (path: string | null | undefined) => {
  if (!path) return undefined;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  return `${BASE_URL}/${cleanPath}`;
};

export default getImageUrl;